(function() {
  function initClientSearch() {
    /** @type {NodeListOf<HTMLInputElement>} */
    const searchInputs = document.querySelectorAll('.js-client-search');
    /** @type {HTMLElement | null} */
    const resultsList = document.querySelector('results-list');
    
    if (!searchInputs.length || !resultsList) return;

    searchInputs.forEach(input => {
      input.addEventListener('input', (e) => {
        const target = /** @type {HTMLInputElement} */ (e.target);
        const query = target.value.trim().toLowerCase();
        filterProducts(query);
      });
      
      input.addEventListener('keydown', (e) => {
        const keyboardEvent = /** @type {KeyboardEvent} */ (e);
        if (keyboardEvent.key === 'Enter') {
          e.preventDefault();
        }
      });
    });

    /**
     * @param {string} query
     */
    function filterProducts(query) {
      if (!resultsList) return;
      /** @type {NodeListOf<HTMLElement>} */
      const cards = resultsList.querySelectorAll('[ref="cards[]"]');
      let visibleCount = 0;

      cards.forEach(card => {
        const text = (card.textContent || '').toLowerCase();
        if (query === '' || text.includes(query)) {
          card.classList.remove('is-hidden');
          visibleCount++;
        } else {
          card.classList.add('is-hidden');
        }
      });
      
      updateNoResultsMessage(visibleCount, query !== '');
    }

    /**
     * @param {number} count
     * @param {boolean} isSearching
     */
    function updateNoResultsMessage(count, isSearching) {
      if (!resultsList) return;
      let noResultsMessage = document.getElementById('ClientSideNoResults');
      const grid = resultsList.querySelector('[ref="grid"]');
      
      if (count === 0 && isSearching) {
        if (!noResultsMessage) {
          noResultsMessage = document.createElement('div');
          noResultsMessage.id = 'ClientSideNoResults';
          noResultsMessage.className = 'search-results__no-results';
          noResultsMessage.style.textAlign = 'center';
          noResultsMessage.style.padding = '2rem';
          noResultsMessage.style.gridColumn = '1 / -1';
          noResultsMessage.innerHTML = `<p>No products found matching your search.</p>`;
          if (grid) grid.appendChild(noResultsMessage);
        } else {
          noResultsMessage.style.display = 'block';
        }
      } else if (noResultsMessage) {
        noResultsMessage.style.display = 'none';
      }
    }

    const grid = resultsList.querySelector('[ref="grid"]');
    if (grid) {
      const observer = new MutationObserver(() => {
        const firstInput = searchInputs[0];
        if (!firstInput) return;
        const activeQuery = firstInput.value.trim().toLowerCase();
        if (activeQuery !== '') {
          filterProducts(activeQuery);
        }
      });
      
      observer.observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClientSearch);
  } else {
    initClientSearch();
  }
})();
